<template>
  <div class="flex-1">
    <div class="flex space-x-4 py-4 justify-center">
      <div>
        <p class="m-0 text-sm mb-1 opacity-50">Период сканов</p>
        <DatePicker
          v-model="period.from"
          type="date"
          format="DD.MM.YYYY"
          placeholder="с"
          :clearable="false"
          :disabled-date="disabledFromPeriod(period)"
        />
      </div>

      <div>
        <p class="m-0 text-sm mb-1 opacity-0">Период сканов</p>
        <DatePicker
          v-model="period.to"
          type="date"
          format="DD.MM.YYYY"
          placeholder="по"
          :clearable="false"
          :disabled-date="disabledToPeriod(period)"
        />
      </div>
    </div>

    <div class="py-4">
      <p class="mx-auto m-0 text-sm text-center">
        Найдено
        {{ predicts.length }}
        {{ pluralize(predicts.length, 'скан', 'скана', 'сканов') }}
      </p>
    </div>

    <div v-if="fetchPredicts.isPending" class="flex justify-center">
      <uiLoader />
    </div>

    <div class="container mx-auto w-full grid pb-8 gap-x-6 gap-y-8 grid-cols-5">
      <div v-for="predict in predicts" :key="predict.id" class="space-y-2">
        <div
          class="cursor-pointer flex bg-gray-100 h-75 items-center justify-center overflow-hidden relative"
          @click="openImageViewer(predict.url)"
        >
          <img
            :src="predict.url"
            class="h-full object-center object-cover w-full top-0 left-0 filter blur-xl absolute"
            alt=""
            loading="lazy"
          />

          <img
            :src="predict.url"
            class="h-full object-center object-contain w-full z-1 relative"
            alt=""
            loading="lazy"
          />
        </div>

        <p class="m-0 text-xs">
          <router-link :to="'/chats/' + predict.user.supportChat">
            Перейти в чат ({{ getFullname(predict.user) }})
          </router-link>
        </p>

        <p v-if="!predict.results?.length" class="m-0 text-base">–</p>

        <p
          v-for="result in predict.results"
          :key="result.id"
          class="border-solid border rounded-lg flex bg-gray-100 border-gray-200 m-0 text-sm p-2 items-center"
          :class="{
            'bg-green-100 border-green-200':
              result.id === predict?.correctedBreed?.id
          }"
        >
          <span class="leading-none pr-3 text-2xl">
            {{ predict.kind === 'dog' ? '🐶' : '🐱' }}
          </span>
          <span>{{ result.name }}</span>
          <span class="ml-auto">{{ result.percent }}%</span>
        </p>

        <div
          v-if="
            predict.correctedBreed &&
            !predict.results
              .map(r => r.id)
              .includes(predict?.correctedBreed?.id)
          "
          class="pt-2"
        >
          <p class="m-0 text-sm">Выбор пользователя:</p>

          <p
            class="border-solid border rounded-lg flex bg-gray-100 border-gray-200 m-0 text-sm p-2 items-center"
          >
            <span class="leading-none pr-3 text-2xl">
              {{ predict.correctedBreed.kind === 'dog' ? '🐶' : '🐱' }}
            </span>
            <span>{{ predict.correctedBreed.name }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import DatePicker from 'vue2-datepicker'
import api from '@/utils/ky'
import { openImageViewer } from '@/utils/events'
import { API } from '@/config'
import { startOfToday, endOfToday, subMonths } from 'date-fns'
import { useAsyncMethod } from '@/utils/async-methods'
import { pluralize } from 'numeralize-ru'
import { getFullname } from '@/utils/name'
import { disabledFromPeriod, disabledToPeriod } from '@/utils/datepicker'

export default {
  components: {
    DatePicker
  },
  setup () {
    const period = reactive({
      from: subMonths(startOfToday(), 1),
      to: endOfToday()
    })
    const predicts = ref([])

    const fetchPredicts = useAsyncMethod(async () => {
      predicts.value = []

      const { data } = await api.get(API.BREEDPREDICTS.list, undefined, {
        searchParams: {
          startDate: period.from?.toJSON(),
          endDate: period.to?.toJSON()
        }
      })
      predicts.value = data
    })

    onMounted(async () => {
      await fetchPredicts()
    })

    watch(period, async val => {
      await fetchPredicts()
    })

    return {
      pluralize,
      getFullname,
      fetchPredicts,
      period,
      predicts,
      openImageViewer,
      disabledFromPeriod,
      disabledToPeriod
    }
  }
}
</script>
